import axios from 'axios';
import { ENDPOINTS } from './endpoints';

/**
 * Fetch homeworks with optional filters and pagination.
 * @param {Object} params
 * @param {number} params.page - Page number (1-based)
 * @param {string|number} params.program_id
 * @param {string|number} params.subject_id
 * @param {string} params.homework_type
 * @param {string|number} params.teacher_id
 * @param {string} params.homework_title
 */
export const getHomeworks = async ({
  page = 1,
  program_id = "",
  subject_id = "",
  homework_type = "",
  homework_title = "",
} = {}) => {
  try {
    // Build query params dynamically
    const queryParams = new URLSearchParams();
    queryParams.append("page", page);
    if (program_id) queryParams.append("program_id", program_id);
    if (subject_id) queryParams.append("subject_id", subject_id);
    if (homework_type) queryParams.append("homework_type", homework_type);
    if (homework_title) queryParams.append("homework_title", homework_title);

    const response = await axios.get(`${ENDPOINTS.HOMEWORK.GET}?${queryParams.toString()}`);
    return response;
  } catch (error) {
    throw error; // Let centralized error handler handle this
  }
};

export const getHomeworkById = async (id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.HOMEWORK.GET_HOMEWORK}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createHomework = async (data) => {
  const axiosConfig = {
    method: 'post',
    url: ENDPOINTS.HOMEWORK.CREATE,
    data: data,
    headers: { "Content-Type": "multipart/form-data" }
  };

  try {
    const response = await axios(axiosConfig)
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateHomework = async (id, data) => {
  const axiosConfig = {
    method: 'post',
    url: `${ENDPOINTS.HOMEWORK.UPDATE}/${id}`,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  try {
    const response = await axios(axiosConfig)
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteHomework = async (id) => {
  try {
    const response = await axios.delete(`${ENDPOINTS.HOMEWORK.DELETE}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
